
import { useState } from 'react';

import { Box, Button, Collapse, Flex, FormControl, FormLabel, Grid, GridItem, HStack, Text } from '@chakra-ui/react'
import { CaretDown, CaretUp, Eraser, Funnel } from '@phosphor-icons/react'
import { useFormContext } from 'react-hook-form';

interface Props {
    fields: Field[],
    handleFilter: () => void
    handleClear: () => void
}

interface Field {
    name: string
    label: string
    colSpan?: number
    component: React.ReactNode
}

const TableFilterBox = ({ fields = [], handleFilter, handleClear }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const { reset } = useFormContext()

    const onClear = () => { reset(); handleClear(); }
    const onFilter = () => handleFilter()

    return (
        <Flex w="full" direction="column" px="4">
            <Flex h="32px" w="full">
                <HStack spacing="3">
                    <Text fontSize="md" fontWeight="bold">
                        Filtros
                    </Text>
                    <Button size="sm" colorScheme="green" onClick={() => setIsOpen(!isOpen)}>
                        {
                            isOpen ?
                                <CaretUp />
                                : <CaretDown />
                        }

                    </Button>
                </HStack>
            </Flex>
            <Collapse in={isOpen} animateOpacity>
                <Flex w="full" direction="column" py="4">
                    <Grid
                        w="full"
                        templateColumns='repeat(6, 1fr)'
                        gap={4}
                    >
                        {
                            fields.map((field, i) => (
                                <GridItem key={i} colSpan={field.colSpan || 1}>
                                    <FormControl>
                                        <FormLabel
                                            fontWeight="bold"
                                            fontSize="xs"
                                        >
                                            {field.label}
                                        </FormLabel>
                                        {field.component}
                                    </FormControl>
                                </GridItem>
                            ))
                        }
                    </Grid>
                    <Flex w="full" justifyContent="end" mt={4}>
                        <HStack spacing="2">
                            <Button size="sm" colorScheme="green" onClick={() => setIsOpen(false)}>
                                <CaretUp />
                            </Button>
                            <Button size="sm" colorScheme="blue" leftIcon={<Eraser weight="duotone" />} onClick={onClear} >
                                Limpar
                            </Button>
                            <Button size="sm" colorScheme="green" leftIcon={<Funnel weight="duotone" />} onClick={onFilter} >
                                Filtrar
                            </Button>
                        </HStack>
                    </Flex>
                </Flex>
            </Collapse >
        </Flex>
    )
}

export default TableFilterBox